export const IN_CALL_MODAL_ACTION_CLOSE = 'IN_CALL_MODAL_ACTION_CLOSE';
export const IN_CALL_MODAL_ACTION_OPEN = 'IN_CALL_MODAL_ACTION_OPEN';
export const IN_CALL_MODAL_SUBCOMPONENT_DEFAULT = 'IN_CALL_MODAL_SUBCOMPONENT_DEFAULT';
export const DESKTOP_REQUEST_MINIMIZE = 'DESKTOP_REQUEST_MINIMIZE';
export const DESKTOP_SEND_MINIMIZE = 'DESKTOP_SEND_MINIMIZE';
